module.exports = __webpack_public_path__ + "static/phone-bfe2e5931ddcfb2f79b1cf0d5511a853.png";